import { timezoneMapping, timezonesLongAbbreviations } from './constants';

const numberOfTimezones = timezonesLongAbbreviations.length;

const longToShortAbbreviation = (dateTime: string): string => {
  // traditional for loop for performance reasons
  for (let i = 0; i < numberOfTimezones; i++) {
    const longAbbr = timezonesLongAbbreviations[i];

    // checking if the current long abbreviation is part of the date time string
    const index = dateTime.indexOf(longAbbr);

    // if yes, we recompose the string with the short abbreviation
    // using slice instead of replace for performance reasons
    if (index !== -1) {
      return `${dateTime.slice(0, index)}${timezoneMapping[longAbbr]}${dateTime.slice(index + longAbbr.length)}`;
    }
  }

  return dateTime;
};

export { longToShortAbbreviation };
